module.exports = __webpack_public_path__ + "static/media/1solution.5fa3308d.svg";